import { useIntercom } from 'react-use-intercom';

const useToggleIntercom = () => {
  const { hide, show, isOpen, showArticle, startSurvey } = useIntercom();

  const toggleIntercom = (articleId?: number) => {
    if (isOpen) {
      hide();
    } else {
      articleId ? showArticle(articleId) : show();
    }
  };

  const toggleIntercomArticle = (articleId: number) => {
    if (isOpen) {
      hide();
    } else {
      showArticle(articleId);
    }
  };
  const toggleIntercomSurvey = (surveyId: number) => {
    if (isOpen) {
      hide();
    } else {
      startSurvey(surveyId);
    }
  };

  return { toggleIntercom, toggleIntercomArticle, toggleIntercomSurvey };
};

export default useToggleIntercom;
